import { MRT_ColumnDef } from "material-react-table";
import type { Job } from "../../../../../api/types";
import { ColumnContext, geoJSONFileColumn } from "./standard-column-types";

export function column_BoundaryGeoJSON(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return geoJSONFileColumn(context, "boundaryOptions", "boundaryGeoJSON", "boundaryGeoJSON");
}

export function column_PointsGeoJSON(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return geoJSONFileColumn(context, "pointsOptions", "pointsGeoJSON", "pointsGeoJSON");
}

export function column_ZonesGeoJSON(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return geoJSONFileColumn(context, "zonesOptions", "zonesGeoJSON", "zonesGeoJSON");
}
